<template>
  <div class="addfollowup">
    <div class="addfollowup--header">
      <div class="addfollowup--header--title">
        <div class="title--back iconfont" @click="handleToForwardRouter">&#xe600;</div>
        <div class="title--text">新增资产检查</div>
      </div>
    </div>
    <div class="addfollowup--line"></div>
    <div class="addfollowup--info">
      <div class="addfollowup--info--item" @click="!(approveStatus==='000' || approveStatus ==='992') && handleToGetAssetsAllList()">
        <div class="item--text">资产名称</div>
        <div class="item--desc">{{assetsName?assetsName:'点击选择'}}</div>
        <div class="item--icon iconfont">
          <template v-if="!(approveStatus==='000' || approveStatus ==='992')">&#xe62c;</template>
        </div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">资产保管位置</div>
        <div class="item--desc">{{assetsLoc}}</div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">资产类型</div>
        <div class="item--desc">{{assetsTypeText}}</div>
      </div>
      <div class="addfollowup--info--item">
        <div class="item--text">抵债金额(万元)</div>
        <div class="item--desc">{{assetsAmount}}</div>
      </div>
      <div class="addfollowup--info--item" @click=" !(approveStatus==='000' || approveStatus ==='992') && handleToRecordToMap()" v-if="false">
        <div class="item--text">检查地址</div>
        <div class="item--desc">{{this.$store.state.locationData.address?this.$store.state.locationData.address:'点击获取定位'}}</div>
        <div class="item--icon iconfont">
          <template v-if="!(approveStatus==='000' || approveStatus ==='992')">&#xe62b;</template>
        </div>
      </div>
      <div class="addfollowup--info--item" v-if="false">
        <div class="item--text">检查时间</div>
        <div class="item--desc">{{this.$store.state.locationData.locationDate}}</div>
        <div class="item--icon iconfont"></div>
      </div>

      <div class="addfollowup--info--img">
        <div class="md-example-child md-example-child-reader md-example-child-reader-0">
          <div>
            <ul class="image-reader-list">
              <li
                class="image-reader-item"
                v-for="(img, index) in followupimgs"
                :key="index"
                @click="showViewer(index, $event)"
                :style="{
                  'backgroundImage': `url(${img})`,
                  'backgroundPosition': 'center center',
                  'backgroundRepeat': 'no-repeat',
                  'backgroundSize': 'cover'
                }"
              >
                <md-tag
                  class="image-reader-item-del"
                  size="small"
                  shape="quarter"
                  fill-color="#111A34"
                  type="fill"
                  font-color="#fff"
                  @click.native.stop="handleToDeleteImage(index)"
                >
                  <md-icon name="close"></md-icon>
                </md-tag>
              </li>
            </ul>
          </div>
          <md-image-viewer
            v-model="followupisViewerShow"
            :list="followupimgs"
            :has-dots="true"
            :initial-index="followupviewerIndex">
          </md-image-viewer>
        </div>
      </div>
      <div class="addfollowup--info--camera">
        <div class="item--img--icon">
          <van-uploader :after-read="afterAddFollowupRead" :multiple="true"/>
        </div>
      </div>
      <div class="addfollowup--info--item">
        <md-textarea-item
          ref="demo0"
          :autosize="true"
          class="example"
          v-model="assetscheckdetail"
          placeholder="本次检查现场情况及问题"
        />
      </div>
      <div class="addfollowup--info--item">
        <md-textarea-item
          ref="demo1"
          :autosize="true"
          class="example"
          v-model="assetsrecommend"
          placeholder="下一步举措建议"
        />
      </div>
      <div class="addfollowup--info--person">
        <div class="item--persons--title">检查人</div>
        <div class="item--persons--desc">
          <div
            class="desc--person"
            v-for="(item,index) in assetsCheckerList"
            :key="item.actorno+index"
          >{{item.actorname}}</div>
          <div
            class="desc--person desc--person--plus iconfont"
            @click="handleToAssetsChecker"
          >&#xe602;</div>
        </div>
      </div>
      <div class="addfollowup--info--text" v-if="approveStatus ==='992'">
        <div
          class="txt-border"
          v-for="info in flowApproveInfoList"
          :key="info.id"
        >
          <div>审批意见:  {{info.approveRemark?info.approveRemark:'同意'}}</div>
          <div>审批人:    {{info.nowFlowUserName}}</div>
          <div>批准时间:  {{info.approveTime}}</div>
        </div>
      </div>
    </div>
    <div class="addfollowup--footer">
      <div class="addfollowup--footer--save" @click="handelToSaveStaff">保存为草稿</div>
      <div class="addfollowup--footer--save" @click="handleToSubmitCheck">提交审批</div>
    </div>
    <div class="addfollowup--visit" v-if="assetsAllListFlag">
      <div class="visit--title">
        <div class="visit--title--text">选择资产</div>
      </div>
      <div class="visit--line"></div>
      <template v-if="assetsAllList.length">
        <div
          class="visit--item"
          v-for="item in assetsAllList"
          :key="item.id"
          @click="handleToSelectAssets(item)"
        >
          <div class="visit--item--icon iconfont">&#xe629;</div>
          <div class="visit--item--text">{{item.assetName}}</div>
        </div>
      </template>
      <template v-else>
        <div
          class="visit--item"
        >
          <div class="visit--item--text">暂无数据</div>
        </div>
      </template>
      <div class="assets-page" v-if="false">
        <van-pagination v-model="pageNum" :page-count="assetsTotal" @change="handelToChangePage" mode="simple" />
      </div>
    </div>
    <div class="addfollowup--visit" v-if="assetsCheckerFlag">
      <div class="visit--title">
        <div class="visit--title--cancle"></div>
        <div class="visit--title--text">选择项目经理</div>
        <div class="visit--title--cancle" @click="handleToCompleteAssetsChecker">完成</div>
      </div>
      <div class="visit--line"></div>
      <div class="visit--person">
        <div
          class="visit--person--content"
          :class="{active:assetsCheckerSelectTag.includes(item.actorno)}"
          v-for="item in assetsCheckerAllList"
          :key="item.actorno"
          @click="handleToAddAssetsChecker(item)"
        >{{item.actorname}}</div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
import { get, postfile, postjson } from '../api/api'
import { compressImage } from '../tools/CompressImageUtils'
import { TextareaItem, ImageViewer, Tag, ImageReader, Icon } from 'mand-mobile'

export default {
  name: 'AddCheck',
  components: {
    [TextareaItem.name]: TextareaItem,
    [ImageViewer.name]: ImageViewer,
    [Tag.name]: Tag,
    [ImageReader.name]: ImageReader,
    [Icon.name]: Icon
  },
  data () {
    return {
      followupisViewerShow: false, // 控制图是否全屏显示
      followupviewerIndex: 0, // 选择那张图片
      followupimgs: [], // 图片列表
      docEReceiveList: [], // 添加图片列表
      assetsAllListFlag: false, // 控制资产列表页面显示
      assetsAllList: [], // 所有资产列表
      id: '', // 资产id
      assetsTotal: '', // 资产总数
      assetNo: '', // 资产编号
      assetsName: '', // 资产名称
      assetsLoc: '', // 资产位置
      assetsType: '', // 资产类型
      assetsTypeText: '', // 资产类型文本
      assetsAmount: '', // 资产金额
      assetscheckdetail: '', // 本次检查现场情况及问题
      assetsrecommend: '', // 下一步举措
      assetsCheckerList: [], // 资产检查人列表
      assetsCheckerFlag: false, // 资产检查人页面显示
      assetsCheckerAllList: [], // 所有资产检查人列表
      assetsCheckerSelectTag: [], // 选中检查人列表
      approveStatus: '', // 判断是否可以编辑000 ，992可以编辑
      flowApproveInfoList: [], // 审批意见
      pageNum: 1, // 资产页码
      pageSize: 500 // 资产条数
    }
  },
  beforeMount () {
    if (this.$route.params.data) {
      this.handelToSingleCheckData(this.$route.params.data)
    } else if (JSON.parse(localStorage.getItem('assetspostData'))) {
      const assetspostData = JSON.parse(localStorage.getItem('assetspostData'))
      this.handleToModifyAssetsCheckData(assetspostData)
    } else {
      this.handleToItemPerson()
    }
  },
  destroyed () {
    this.$store.commit('delLocationInfo', '')
  },
  methods: {
    // 读取压缩照片内容
    async afterAddFollowupRead (fileList) {
      if (Array.isArray(fileList)) {
        for (let i = 0; i < fileList.length; i++) {
          await this.handleToSendPic(fileList[i])
        }
      } else {
        await this.handleToSendPic(fileList)
      }
    },
    // 上传图片
    async handleToSendPic (file) {
      const imgData = await compressImage(file.content)
      const beforeSize = (file.file.size / 1024 / 1024).toFixed(2)
      const afterSize = (imgData.size / 1024 / 1024).toFixed(2)
      const uploadData = (beforeSize < 1 || afterSize > beforeSize) ? file.file : imgData
      const formdata = new FormData()
      formdata.append('file', uploadData, file.file.name)
      const result = await postfile('/api/CBMS-APP/docEReceive/upload', formdata)
      if (result.success) {
        this.docEReceiveList.push({
          downloadUrl: result.data.downloadUrl,
          pk: result.data.pk
        })
        this.followupimgs.push(result.data.downloadUrl)
      } else {
        this.$toast.success('上传图片出错')
        return false
      }
    },
    // 显示图片
    showViewer (index) {
      this.followupviewerIndex = index
      this.followupisViewerShow = true
    },
    // 删除照片
    handleToDeleteImage (index) {
      const imgUrl = this.followupimgs[index]
      this.$dialog.confirm({
        title: '',
        message: '确认删除该照片'
      })
        .then(async () => {
          this.docEReceiveList = this.docEReceiveList.filter(item => item.downloadUrl !== imgUrl)
          this.followupimgs.splice(index, 1)
        })
        .catch(() => {
          this.$toast.success('已取消')
        })
    },
    // 修改资产数据
    handleToModifyAssetsCheckData (item) {
      for (const key in item) {
        if ((key === 'address' || key === 'lng' || key === 'lat' || key === 'locationDate')) {
          const payLoad = { ...this.$store.state.locationData, [key]: item[key] }
          this.$store.commit('setLocationFunc', payLoad)
        } else {
          this[key] = item[key]
        }
      }
    },
    // 处理hisassets路由跳转过来的数据
    handelToSingleCheckData (item) {
      this.id = item.id
      this.approveStatus = item.approveStatus
      this.assetNo = item.assetNo
      this.assetsName = item.assetName
      this.assetsLoc = item.assetLocation
      this.assetsType = item.assetType
      this.assetsTypeText = item.assetTypeName
      this.assetsAmount = item.payDebtAmount
      this.assetscheckdetail = item.checkDesc
      this.assetsrecommend = item.nextMeasures
      this.docEReceiveList = item.docEReceiveList
      this.assetsCheckerList = item.mmRecordStaffList
      this.flowApproveInfoList = item.flowApproveInfoList
      const payLoad = { ...this.$store.state.locationData }
      payLoad.address = item.address
      payLoad.lng = item.lng
      payLoad.lat = item.lat
      payLoad.locationDate = item.locationDate
      this.$store.commit('setLocationFunc', payLoad)
      this.docEReceiveList.forEach(imgitem => {
        this.followupimgs.push(imgitem.downloadUrl)
      })
    },
    // 添加登陆人到项目成员
    handleToItemPerson () {
      this.assetsCheckerList.push({
        actorname: this.$cookies.get('actorname'),
        actorno: this.$cookies.get('actorno')
      })
      this.assetsCheckerSelectTag.push(this.$cookies.get('actorno'))
    },
    // 获取资产列表
    async handleToGetAssetsAllList () {
      const result = await get('/api/CBMS-APP/mmassetinfo/list', {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.assetsAllListFlag = true
        this.assetsAllList = result.data.records
        this.assetsTotal = Math.ceil(result.data.total / this.pageSize)
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 资产列表换页
    async handelToChangePage () {
      await this.handleToGetAssetsAllList()
    },
    // 选择资产
    handleToSelectAssets (itemObj) {
      this.assetNo = itemObj.assetNo
      this.assetsName = itemObj.assetName
      this.assetsLoc = itemObj.assetLocation
      this.assetsType = itemObj.assetType
      this.assetsTypeText = itemObj.assetTypeName
      this.assetsAmount = itemObj.payDebtAmount
      document.body.style.overflow = 'auto'
      this.assetsAllListFlag = false
    },
    // 跳转到新增资产
    handleToForwardAddAssets () {
      document.body.style.overflow = 'auto'
      this.assetsAllListFlag = false
      this.$router.push({ name: 'addassets', params: { routerName: 'addcheck' } })
    },
    // 获取项目经理
    async handleToAssetsChecker () {
      const result = await get('/api/CBMS-APP/sUser/listByComBrIdAndDuty', { dutyno: '0129' })
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.assetsCheckerFlag = true
        this.assetsCheckerAllList = result.data.records
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 添加检查人
    handleToAddAssetsChecker (itemObj) {
      if (this.assetsCheckerSelectTag.includes(itemObj.actorno)) {
        this.assetsCheckerSelectTag.splice(this.assetsCheckerSelectTag.indexOf(itemObj.actorno), 1)
        this.assetsCheckerList = this.assetsCheckerList.filter(item => item.actorno !== itemObj.actorno)
      } else {
        this.assetsCheckerList.push({
          actorname: itemObj.actorname,
          actorno: itemObj.actorno
        })
        this.assetsCheckerSelectTag.push(itemObj.actorno)
      }
    },
    // 完成检查人选择
    handleToCompleteAssetsChecker () {
      document.body.style.overflow = 'auto'
      this.assetsCheckerFlag = false
    },
    // 新增资产保存为草稿
    async handelToSaveStaff () {
      if (!this.assetsName) {
        this.$toast.success('资产名称不能为空')
        return false
      }
      // if (!this.$store.state.locationData.address) {
      //   this.$toast.success('检查地址不能为空')
      //   return false
      // }
      const postData = {
        id: this.id,
        assetNo: this.assetNo,
        assetName: this.assetsName,
        assetLocation: this.assetsLoc,
        assetType: this.assetsType,
        payDebtAmount: this.assetsAmount,
        address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '',
        lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '',
        lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '',
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
        checkDesc: this.assetscheckdetail,
        nextMeasures: this.assetsrecommend,
        docEReceiveList: this.docEReceiveList,
        mmRecordStaffList: this.assetsCheckerList
      }
      const result = await postjson('/api/CBMS-APP/mmassetcheck/addMmAssetCheck', postData)
      if (result.success) {
        this.$toast.success({
          message: '新增资产检查已保存为草稿',
          onClose: () => {
            this.$router.push('/homeassets')
          }
        })
      } else {
        this.$toast.success('新增资产检查保存草稿失败')
      }
    },
    // 新增资产提交审批
    async handleToSubmitCheck () {
      if (!this.assetsName) {
        this.$toast.success('资产名称不能为空')
        return false
      }
      if (!this.assetscheckdetail) {
        this.$toast.success('本次检查内容不能为空')
        return false
      }
      if (!this.assetsrecommend) {
        this.$toast.success('下一步举措建议不能为空')
        return false
      }
      // if (!this.$store.state.locationData.address) {
      //   this.$toast.success('检查地址不能为空')
      //   return false
      // }
      const _this = this
      const postData = {
        id: this.id,
        assetNo: this.assetNo,
        assetName: this.assetsName,
        assetLocation: this.assetsLoc,
        assetType: this.assetsType,
        payDebtAmount: this.assetsAmount,
        address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '110',
        lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '120',
        lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '130',
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '120',
        checkDesc: this.assetscheckdetail,
        nextMeasures: this.assetsrecommend,
        docEReceiveList: this.docEReceiveList,
        mmRecordStaffList: this.assetsCheckerList
      }

      this.$dialog.confirm({
        title: _this.assetsName,
        message: '确认提交审批'
      })
        .then(async () => {
          const result = await postjson('/api/CBMS-APP/mmassetcheck/submitflow', postData)
          if (result.success) {
            this.$toast.success({
              message: '新增资产检查提交审批成功',
              onClose: () => {
                this.$router.push('/homeassets')
              }
            })
          } else {
            this.$toast.success('新增资产检查提交审批失败')
          }
        })
        .catch(() => {
          this.$toast.success('已取消')
        })
    },
    // 路由跳转
    handleToForwardRouter () {
      const routerName = this.$route.params.routerTag
      if (routerName) {
        this.$router.push({ name: routerName })
      } else {
        this.$router.push({ name: 'homeassets' })
      }
    },
    // 跳转到地图页面
    handleToRecordToMap () {
      const modifyTag = this.$route.params.modifyTag
      const routerName = this.$route.params.routerName
      const id = this.$route.params.id
      this.$router.push({ name: 'marketmap', params: { localName: 'addcheck', modifyTag, routerName, id } })
    }
  },
  beforeRouteLeave (to, from, next) {
    const assetspostData = {
      followupimgs: this.followupimgs,
      docEReceiveList: this.docEReceiveList,
      assetsAllList: this.assetsAllList,
      assetsTotal: this.assetsTotal,
      assetNo: this.assetNo,
      assetsName: this.assetsName,
      assetsLoc: this.assetsLoc,
      assetsType: this.assetsType,
      assetsTypeText: this.assetsTypeText,
      assetsAmount: this.assetsAmount,
      assetscheckdetail: this.assetscheckdetail,
      assetsrecommend: this.assetsrecommend,
      assetsCheckerList: this.assetsCheckerList,
      assetsCheckerAllList: this.assetsCheckerAllList,
      assetsCheckerSelectTag: this.assetsCheckerSelectTag,
      flowApproveInfoList: this.flowApproveInfoList
    }
    if (to.name === 'marketmap' && from.name === 'addcheck') {
      localStorage.setItem('assetspostData', JSON.stringify(assetspostData))
      next()
    } else {
      localStorage.removeItem('assetspostData')
      next()
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.addfollowup
  position : relative
  width : 100vw
  min-height : 100vh
  background-color : #f7f7f7
  overflow-x : hidden
  overflow-y : scroll
  padding-bottom : 96px
  .addfollowup--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .addfollowup--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      align-items : center
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--cancle
        width : 120px
        padding-left : 16px
        text-align : left
      .title--complete
        width : 120px
        padding-right : 16px
        text-align : right
      .title--text
        flex : 1
        text-align : center
      .title--back
        font-size: 38px
        width : 100px
        padding :0 16px
        box-sizing : border-box
  .addfollowup--line
    height : 85px
    width : 100vw
  .addfollowup--info
    .addfollowup--info--noinput
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
    .addfollowup--info--item
      display : flex
      justify-content : center
      align-items : center
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &:nth-child(1)
        margin-top : 0
      .item--text
        width : 200px
      .item--desc
        flex : 1
        text-align : left
        text-indent : 32px
      .item--report
        flex : 1
        text-align : right
        color : #007aff
        text-decoration: underline
      .item--radio
        flex : 1
        &>>>.van-radio-group
          padding-left : 16px
      .item--icon
        width : 100px
        text-align : right
        font-size: 34px
        color : #4282e1
      &>>>.md-field-item
        width : 100vw
      &>>>.md-field-item-content:before
        border-bottom : none
    .addfollowup--info--text
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .txt-border
        margin : 8px
        padding : 8px
        border-radius : 12px
        border : 1px solid #bdb9b9
    .addfollowup--info--camera
      display : flex
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--img--icon
        text-align : center
        line-height : 47px
        font-size: 48px
        color : #4282e1
        &>>>.van-uploader__upload
          height : 47px
          background-color : #ffffff
          margin : 0
        &>>>.van-uploader__upload-icon
          color : #4282e1
          font-size: 64px
    .addfollowup--info--img
      margin : 16px 8px
      .md-example-child-reader
        .image-reader-list
          background-color : #ffffff
          float : left
          width : 100%
          .image-reader-item
            position : relative
            float : left
            width : 23.5%
            padding-bottom : 23.5%
            margin-bottom : 2%
            margin-right : 2%
            background : #FFF
            box-shadow : 0 5px 20px rgba(197, 202, 213, .25)
            box-sizing : border-box
            list-style : none
            border-radius : 4px
            background-size : cover
            overflow : hidden
            &:nth-of-type(4n)
              margin-right : 0
            &.add
              .md-icon
                position : absolute
                top : 40%
                left : 50%
                transform : translate(-50%, -50%)
                opacity : .5
              p
                position : absolute
                top : 50%
                left : 0
                width : 100%
                margin-top : 15px
                font-size : 22px
                color : #CCC
                text-align : center
            .image-reader-item-del
              position : absolute
              top : 0
              right : 0
              z-index : 3
              opacity : .8
              .md-icon-close
                font-size : 24px
    .addfollowup--info--person
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--persons--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .item--persons--desc
        display : flex
        align-items : center
        padding : 16px 0
        border-bottom : 1px solid #8b8787
        .desc--person
          background-color : #4282e1
          margin-right : 32px
          width : 100px
          height : 100px
          line-height : 100px
          text-align : center
          border-radius : 50%
          color : #ffffff
          font-family: MyriadPro-Regular
          font-size: 28px
          font-weight: normal
          font-stretch: normal
        .desc--person--plus
          font-size : 32px
    .addfollowup--info--version
      margin-top : 16px
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .version--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .version--item
        display : flex
        align-items : center
        padding : 16px 0
        line-height : 1.5
        background-color : #ffffff
        border-bottom : 1px solid #8b8787
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .version--item--text
          width : 250px
        .version--item--desc
          flex : 1
        .version--item--icon
          width : 100px
          text-align : right
          font-size: 34px
        &.active
          background-color : #007aff
          .version--item--text,.version--item--icon
            color : #ffffff
  .addfollowup--footer
    position : fixed
    left : 0
    bottom :0
    width : 100vw
    display : flex
    z-index : 100
    .addfollowup--footer--save,.addfollowup--footer--del
      flex : 1
      text-align : center
      padding : 32px 0
      background-color : #eabf62
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
    .addfollowup--footer--save
      border-right : 1px solid #ffffff
    .addfollowup--footer--del
      border-left : 1px solid #ffffff
  .addfollowup--visit
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 110
    overflow-y : scroll
    .visit--title
      position : fixed
      top: 0
      left: 0
      width : 100vw
      z-index : 12
      display : flex
      background-color : #687591
      .visit--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .visit--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 16px 0 16px 16px
        color : #ffffff
      .title--add
        width : 100px
        font-size: 38px
        padding : 16px 16px 16px 0
        text-align : right
        color : #ffffff
    .visit--line
      height : 80px
    .visit--item
      display : flex
      align-items : center
      margin : 16px 32px 0 32px
      border-radius : 12px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      border : 1px solid #007aff
      color: #333333
      .visit--item--icon
        padding : 16px
        width : 48px
        color: #4282e1
      .visit--item--text
        flex : 1
        padding: 16px
        text-align : left
        .text-title
          padding-bottom : 8px
          font-size: 32px
          font-weight: normal
          font-stretch: normal
        .text-desc
          padding-top : 8px
          color : #007aff
    .visit--person
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .visit--person--content
        width : calc(25% - 16px)
        padding : 16px 0
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        text-align : center
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
    .assets-page
      position : fixed
      bottom: 0
      left : 0
      width : 100%
      &>>>.van-pagination__item
        height : 96px
        font-size : 32px
      &>>>.van-pagination__page-desc
        height : 96px
        font-size : 28px
  &>>>.md-popup-cancel
    font-size : 38px
    padding-left : 28px
  &>>>.md-popup-confirm
    font-size : 38px
    padding-right : 28px
</style>
